import React, { useEffect, useState } from "react";
import { MdModeEditOutline, MdDelete,} from "react-icons/md";
import { getJobDetailsApi, addJobDetailApi, updateJobDetailApi, deleteJobDetailApi } from "Services/allApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const JobDetail = ({job}) => {
  // const { jobId } = useParams();
  // const navigate = useNavigate();
  // const jobTitle = location.state?.jobTitle || "Default Title";
  const [jobDetails, setJobDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newDetail, setNewDetail] = useState({ detail_type: "", content: "", job_post: job.id });
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false); 
  const [editDetail, setEditDetail] = useState(null); 
  const [detailToDelete, setDetailToDelete] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    fetchJobDetails();
  }, [job]);

  const fetchJobDetails = async () => {
    setLoading(true);
    try {
      const response = await getJobDetailsApi(job.id);
      if (response && !response.error) {
        setJobDetails(response.data);
      } else {
        toast.error("Failed to fetch job details!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
    setLoading(false);
  };

  const validateJobDetailFields = (detail) => {
    return (
      detail.detail_type.trim() !== "" &&
      detail.content.trim() !== ""
    );
  };
  

  const handleAddDetail = async () => {
    if (!validateJobDetailFields(newDetail)) {
      toast.error("Please fill in all fields!");
      return;
    }
    try {
      const response = await addJobDetailApi(newDetail);
      if (response && !response.error) {
        toast.success("Job detail added successfully!");
        setNewDetail({ detail_type: "", content: "", job_post: job.id });
        fetchJobDetails(); // Refresh the job details
        setModalOpen(false); // Close the modal after submitting
      } else {
        toast.error("Failed to add job detail!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
  };

  const handleUpdateDetail = async () => {
    if (!validateJobDetailFields(editDetail)) {
      toast.error("Please fill in all fields!");
      return;
    }
    try {
      const updatedDetail = { ...editDetail };
      const response = await updateJobDetailApi(editDetail.id, updatedDetail);
      if (response && !response.error) {
        toast.success("Job detail updated successfully!");
        fetchJobDetails(); 
        setEditModalOpen(false); 
      } else {
        toast.error("Failed to update job detail!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
  };

  const handleDeleteClick = (detail) => {
    setDetailToDelete(detail);
    setDeleteModalOpen(true);
  };

  const confirmDeleteDetail = async () => {
    if (detailToDelete) {
      try {
        const response = await deleteJobDetailApi(detailToDelete.id);
        if (response && !response.error) {
          toast.success("Job detail deleted successfully!");
          fetchJobDetails();
        } else {
          toast.error("Failed to delete job detail!");
        }
      } catch (error) {
        toast.error("An unexpected error occurred!");
      }
      setDeleteModalOpen(false);
      setDetailToDelete(null);
    }
  };
  // const handleGoBack = () => {
  //   navigate("/admin/job-post");
  // };

  const handleEditDetail = (detail) => {
    setEditDetail(detail); 
    setEditModalOpen(true);
  };

  return (
    <>
      <div className="w-full p-4 h-full">
        <div className="mb-8 flex justify-end items-center">
          {/* <h4 className="text-xl font-bold text-navy-700 dark:text-white">Job Details</h4> */}
          <button onClick={() => setModalOpen(true)} className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-700">
             Add Job Detail
          </button>
          {/* <button onClick={() => navigate("/admin/job-post")} className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-purple-700">
            Back to Jobs
          </button> */}
        </div>

        {loading ? (
          <p className="text-center text-purple-800">Loading job details...</p>
        ) : jobDetails.length > 0 ? (
          <div className="my-6">
            {/* <h4 className="text-lg font-semibold mb-2">{jobTitle}</h4> */}
            <div className="space-y-4">
              {jobDetails.map((detail) => (
                <div key={detail.id} className="flex justify-between bg-white p-4 rounded-lg shadow-md  dark:bg-gray-800 dark:text-white">
                  <div>
                    <h5 className="font-medium">{detail.detail_type}</h5>
                    <p>{detail.content}</p>
                  </div>
                  <div className="flex space-x-4">
                    <MdModeEditOutline
                      onClick={() => handleEditDetail(detail)}
                      className="text-yellow-500 hover:text-yellow-700" size={22}
                    />
                      
                    
                    <MdDelete
                     onClick={() => handleDeleteClick(detail)}
                      className="text-red-500 hover:text-red-700" size={22}
                    />
                    
                    
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-center text-red-500">No job details available.</p>
        )}

        {/* Add Job Detail Modal */}
        {modalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 ">
            <div className="bg-white p-6 rounded-lg w-1/2  dark:bg-gray-800  dark:text-white">
              <h2 className="text-lg font-bold mb-4">Add Job Detail</h2>
              <select
                className="w-full p-2 border rounded mb-2 dark:bg-gray-800 dark:text-white"
                value={newDetail.detail_type}
                onChange={(e) => setNewDetail({ ...newDetail, detail_type: e.target.value })}
              >
                <option value="">Select Detail Type</option>
                <option value="Responsibility">Responsibility</option>
                <option value="Requirement">Requirement</option>
              </select>
              <textarea
                placeholder="Content"
                className="w-full p-2 border rounded mb-2 dark:bg-gray-800 dark:text-white"
                value={newDetail.content}
                onChange={(e) => setNewDetail({ ...newDetail, content: e.target.value })}
              />
              <div className="flex justify-between">
                <button
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                  onClick={() => setModalOpen(false)} // Close modal
                >
                  Cancel
                </button>
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={handleAddDetail}
                >
                  Add Detail
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Job Detail Modal */}
        {editModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg w-1/2  dark:bg-gray-800  dark:text-white">
              <h2 className="text-lg font-bold mb-4">Edit Job Detail</h2>
              <select
                className="w-full p-2 border rounded mb-2 dark:bg-gray-800 dark:text-white"
                value={editDetail.detail_type}
                onChange={(e) => setEditDetail({ ...editDetail, detail_type: e.target.value })}
              >
                <option value="Responsibility">Responsibility</option>
                <option value="Requirement">Requirement</option>
              </select>
              <textarea
                placeholder="Content"
                className="w-full p-2 border rounded mb-2 dark:bg-gray-800 dark:text-white"
                value={editDetail.content}
                onChange={(e) => setEditDetail({ ...editDetail, content: e.target.value })}
              />
              <div className="flex justify-between">
                <button
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                  onClick={() => setEditModalOpen(false)} // Close modal
                >
                  Cancel
                </button>
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={handleUpdateDetail}
                >
                  Update Detail
                </button>
              </div>
            </div>
          </div>
        )}
        

         {/* Delete Confirmation Modal */}
         {deleteModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg w-96 text-center dark:bg-gray-800 dark:text-white">
              <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
              <p className="mb-4">Are you sure you want to delete this job detail?</p>
              <div className="flex justify-center space-x-4">
                <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setDeleteModalOpen(false)}>
                  Cancel
                </button>
                <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={confirmDeleteDetail}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      

      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </>
  );
};

export default JobDetail;
